import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";

function Index(props) {
  const { slug } = useParams();
  const { setting } = useSelector((state) => state.setting || {});

  const [getViewData, setGetViewData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getNewsletterData = () => {
    if (!slug) {
      setError("No newsletter slug provided");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    
    agent
      .get(API.NEWSLETTER_DETAIL_DATA + "/" + slug, {})
      .then((res) => {
        setGetViewData(res?.data?.data || {});
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to load newsletter data");
        setLoading(false);
      });
  };

  useEffect(() => {
    getNewsletterData();
  }, [slug]);

  const siteName = setting?.name?.trim() || "Newsletter";

  useEffect(() => {
    const title = `${siteName} - Newsletter`;
    document.title = title;
  }, [siteName]);

  const prepareHtml = (description) => {
    return { __html: description || "" };
  };

  if (loading) {
    return (
      <div>
        <section className="">
          <div className="page_content newsletter-html">
            <Container>
              <div className="text-center">Loading newsletter...</div>
            </Container>
          </div>
        </section>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <section className="">
          <div className="page_content newsletter-html">
            <Container>
              <div className="text-center text-danger">{error}</div>
            </Container>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div>
      <section className="">
        <div className="page_content newsletter-html">
          <Container>
            <div
              dangerouslySetInnerHTML={prepareHtml(
                getViewData.description
              )}
            ></div>
          </Container>
        </div>
      </section>
    </div>
  );
}

Index.propTypes = {
  // Props are now optional since we're using Redux and useParams
};

export default Index;

